//Type values are expected to match with backend/DB

export default {
    Checklist: 'Checklist',
    Radiolist: 'Radiolist',
    Select: 'Select',
    MultiSelectFilter: 'MultiSelectFilter',
    RangeSlider: 'RangeSlider'
};